import { render, staticRenderFns } from "./push-configuration.vue?vue&type=template&id=0f4c32c2&"
import script from "./push-configuration.vue?vue&type=script&lang=js&"
export * from "./push-configuration.vue?vue&type=script&lang=js&"
import style0 from "./push-configuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports